import React from 'react';

// Banner em destaque avisando a aluna que o plano está perto de vencer —
// usado no topo da tela Hoje e do Dashboard (Treino/Nutrição).
export default function RenovacaoBanner({ dias, lang }) {
  if (dias === null || dias > 14) return null;
  const critico = dias <= 7;
  const pt = lang === 'pt';
  const titulo = dias <= 0
    ? (pt ? 'Seu plano venceu!' : 'Your plan has expired!')
    : dias === 1
    ? (pt ? 'Seu plano vence amanhã!' : 'Your plan expires tomorrow!')
    : (pt ? `Seu plano vence em ${dias} dias.` : `Your plan expires in ${dias} days.`);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: '14px', flexWrap: 'wrap',
      padding: '16px 18px', borderRadius: '20px', marginBottom: '18px',
      background: critico ? '#E53935' : 'var(--accent)',
      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    }}>
      <span style={{ fontSize: '24px', flexShrink: 0 }}>{critico ? '⏰' : '📅'}</span>
      <div style={{ flex: 1, minWidth: '160px' }}>
        <div style={{ fontSize: '15px', fontWeight: 700, color: '#FFF6ED' }}>{titulo}</div>
        <div style={{ fontSize: '12px', color: 'rgba(255,246,237,0.85)', marginTop: '2px' }}>
          {pt ? 'Fale com a equipe pra não perder o acesso.' : "Contact the team so you don't lose access."}
        </div>
      </div>
      <a href={`https://wa.me/19549974866?text=${encodeURIComponent('Olá, gostaria de renovar meu plano!')}`} target="_blank" rel="noreferrer"
        style={{ padding: '9px 16px', background: '#FFF6ED', color: critico ? '#E53935' : 'var(--accent)', borderRadius: '100px', fontSize: '12px', fontWeight: 700, textDecoration: 'none', whiteSpace: 'nowrap' }}>
        {pt ? 'Renovar agora' : 'Renew now'}
      </a>
    </div>
  );
}
